module.exports = __webpack_public_path__ + "static/media/full-screen-image-g7.a774b297.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/full-screen-image-g7.jpg
// module id = 218
// module chunks = 0